import { jwtDecode } from "jwt-decode";

import { initialAuthContext } from "./auth.context";

interface IdTokenClaims {
  sub: string;
  email?: string;
  name?: string;
  picture?: string;
  "cognito:groups"?: string[];
}

export const parseProfileFromIdToken = (idToken: string) => {
  const claims = jwtDecode<IdTokenClaims>(idToken);

  return {
    id: claims.sub,
    name: claims.name || claims.email || "",
    avatar: claims.picture || "",
    email: claims.email || "",
    groups: claims["cognito:groups"] || [],
  };
};

export const getEmptyUserProfile = () => initialAuthContext.profile;
